<template>
  <div class="scheduleDetail_medalDetail">
    <NOT_DATA :className="'relativePtb60'" v-if="list && list.length == 0" />
    <div class="medal_list" v-else>
      <span class="medal_item" v-for="(item, index) in list" :key="index">
        <span class="medal_top_icon" :class="item.medalType"></span>
        <span class="medal_icon" :class="item.medalType"></span>
        <span class="sport_infor">
          <span class="matchName" v-text="item.matchName"></span>
          <span class="palyerNames" v-text="item.palyerNames"></span>
        </span>
        <span class="medal_date" v-text="item.medalDate"></span>
      </span>
    </div>
    <!-- <p class="noDataClass" v-show="noData">暂无数据</p> -->
  </div>
</template>

<script>
import { https_delegationDetail_medalList } from '@api/platfrom_compreSportsMeet_api'
import NOT_DATA from '@components/base/NO_DATA.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'scheduleDetail_medalDetail',
  mixins: [cup_base_data_mixin],
  components: {
    NOT_DATA,
  },
  props: {},
  computed: {
    // noData() {
    //   return this.list && this.list.length === 0
    // },
  },
  data() {
    return {
      list: null,
    }
  },
  created() {
    this.query = this.$route.query
    this.init()
  },
  methods: {
    init() {
      this.getList()
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    async getList() {
      await https_delegationDetail_medalList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        delegationId: this.query.delegationId,
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              this.list = res.data.map((item) => {
                item.matchName = `${this._valPerFormatHandler(
                  item.disciplineName
                )}·${this._valPerFormatHandler(item.eventName)}`
                item.palyerNames =
                  item.athleteNames && item.athleteNames.length > 1
                    ? item.athleteNames.join(' / ')
                    : item.athleteNames[0]
                return item
              })
            } else {
              console.debug('暂无数据')
              this.list = []
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.scheduleDetail_medalDetail {
  height: auto;
  width: 100%;
  padding-top: 3.125vw;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: flex-start;
  .medal_list {
    width: 100%;
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding-bottom: 2.778vw;
    .medal_item {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: auto;
      padding: 1.042vw 1.042vw 1.042vw 0;
      background-color: var(--mixtmt_greyColor8);
      border-radius: 0.556vw;
      margin-bottom: 1.38vw;
      .medal_top_icon {
        margin-right: 0.694vw;
        position: relative;
        width: 4.16vw;
        height: 2.778vw;
        overflow: hidden;
        &::before {
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 2;
          content: '\20';
          transform: translate(-50%, -50%);
          width: 2.778vw;
          height: 1.25vw;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
        }
        &.ME_GOLD {
          background: linear-gradient(137deg, #eed99f 0%, #b09445 100%);
          &::before {
            background-image: var(--mixtmt_medalist_top1_icon);
          }
        }
        &.ME_SILVER {
          background: linear-gradient(137deg, #dbe1e8 0%, #95999c 100%);
          &::before {
            background-image: var(--mixtmt_medalist_top2_icon);
          }
        }
        &.ME_BRONZE {
          background: linear-gradient(137deg, #f5c9ad 0%, #a86e4b 100%);
          &::before {
            background-image: var(--mixtmt_medalist_top3_icon);
          }
        }
      }
      .medal_icon {
        width: 2.778vw;
        height: 2.778vw;
        overflow: hidden;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        &.ME_GOLD {
          background-image: var(--mixtmt_gold_num_icon);
        }
        &.ME_SILVER {
          background-image: var(--mixtmt_silver_num_icon);
        }
        &.ME_BRONZE {
          background-image: var(--mixtmt_bronze_num_icon);
        }
      }
      .sport_infor {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-direction: column;
        width: calc(100% - 13.182vw);
        padding: 0 3.47vw 0 5.55vw;
        height: 2.917vw;
        color: var(--mixtmt_blackColor);
        .matchName,
        .palyerNames {
          font-size: 1.11vw;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 1.11vw;
          height: 1.11vw;
        }
      }
      .medal_date {
        width: 5.55vw;
        font-size: 1.11vw;
        color: var(--mixtmt_greyColor2);
      }
    }
  }
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
}

.mixtmt_pc .scheduleDetail_medalDetail {
}
</style>
